<div class="dialog">
  <h1>Choose Location</h1>
  <app-finder
    [currentGallery]="moveToGallery"
    [currentFolder]="selectedFolder"
    (onSelectGallery)="selectGallery($event)"
    (onSelectFolder)="selectFolder($event)"
    [filterOut]="[]"
    [reOpenFn]="reOpenFn()"
  >
  </app-finder>
  <br />
  <div class="bottom-row">
    <div class="fake-radio" [class.active]="mode === 'move'" (click)="changeMode('move')">
      Move
      @if (assets.length !== 1) {
        Assets
      } @else {
        Asset
      }
    </div>
    <div class="fake-radio" [class.active]="mode === 'copy'" (click)="changeMode('copy')">
      Copy
      @if (assets.length !== 1) {
        Assets
      } @else {
        Asset
      }
    </div>
    <div class="spacer"></div>
    <button
      appButton
      name="confirm"
      location="move-assets-dialog"
      [analyticsExtra]="{ mode: mode }"
      color="primary"
      (click)="confirm()"
      weight="bold"
      shape="round"
      [class.disabled]="!moveToGallery"
    >
      @if (mode === 'move') {
        <span [class.hidden-text]="loading"
          >Move
          @if (assets.length !== 1) {
            Assets
          } @else {
            Asset
          }
        </span>
      }
      @if (mode === 'copy') {
        <span [class.hidden-text]="loading"
          >Copy
          @if (assets.length !== 1) {
            Assets
          } @else {
            Asset
          }
        </span>
      }
      @if (loading) {
        <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
      }
    </button>
  </div>
</div>
